import React, { Component } from 'react';

import './Contact.css';

import en from '../../../language/en/Contact.json';
import es from '../../../language/es/Contact.json';
import { Container, Grid, Icon, Typography } from '@material-ui/core';
import L from 'leaflet';
import config from '../../../config/config.json';

class Contact extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			//datos del correo
			name: '',
			mail: '',
			subject: '',
			phone: '',
			message: ''
		};
		window.scrollTo(0, 0);
	}

	getEmailData(e) {
		const { value, name } = e.target;
		this.setState({
			[name]: value
		});
		//console.log('currentState = ', this.state);
	}

	sendEmail() {
		if (this.validatedEmailData()) {

			const url = `${config.apiBaseUrl}/send_email`;

			const to = 'meteorologia@scu.insmet.cu';
			const data = 'to=' + to + '&subject=' + this.state.subject + '&message=' + this.state.message
				+ '&name=' + this.state.name + '&mail=' + this.state.mail + '&phone=' + this.state.phone
				+ '&nocache=' + Math.random();
			//console.log('data submited', data);

			//Haciendo la petición al servidor para enviar el correo
			fetch(url, {
				method: 'POST',
				body: data,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded' //x-www-form-urlencoded
				}
			})
				.then(res => res.json())
				.then(data => console.log('data = ', data))
				.catch(err => console.log("error: ", err));

			console.log('sending email...');
		}
		else {
			console.log('No se pudo enviar el correo. Verifique sus datos.')
		}
	}

	/*
	*	 Valida los campos del formulario para enviar un correo.
	*	 Retorna true si el formulario no tiene campos vacios y
	*	la dirección de correo escrita es válida.
	*/
	validatedEmailData() {
		const { name, mail, subject, phone, message } = this.state;
		return (name && mail && subject && phone && message && this.isValid(mail));
	}

	isValid(mail) {
		//Un correo válido tiene la forma user@algo.algo
		const arr = mail.split('@');
		console.log('array splited = ', arr);
		console.log('index of @ is: ', mail.indexOf('@'));

		return (/\w{1,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,3}$/.test(mail));
	}

	componentDidMount() {
		let mapop = L.map('map', {
			maxBounds: L.latLngBounds([22, -78], [19, -73]),
			minZoom: 7,
			fullscreenControl: true,
			timeDimension: true,
			timeDimensionControl: true,
			timeDimensionControlOptions: {
				autoPlay: false,
				minSpeed: 0.5,
				speedStep: 0.5,
				maxSpeed: 5,
				playerOptions: {
					buffer: 10,
					transitionTime: 1000,
					loop: true,
				}
			}
		}).setView([20.03035, -75.80135], 15);

		let OSM_CMP = L.tileLayer(`${config.baseUrl}/mapas/osm_tiles/{z}/{x}/{y}.png`, { //wwww.cmpscu.cu/mapas
			attribution: 'Map data: &copy; <a target="_blank" href="https://www.openstreetmap.org/copyright">Colaboradores de OpenStreetMap</a> | &copy; <a target="_blank" href="http://www.cmpscu.cu/" title="Servidor de Mapas CMP Santiago de Cuba">Meteorología Santiago de Cuba</a>',
			bounds: L.latLngBounds([29.76438, -92.41699], [13.43237, -61.83105]),
			minZoom: 7,
		});
		OSM_CMP.addTo(mapop);
		var marker = L.marker([20.03035, -75.80135]).addTo(mapop);
		marker.bindPopup("<b>Centro Meteorológico Provincial</b><br><i style='margin-left: 45px;'>Santiago de Cuba</i>")
			.openPopup();
	}

	render() {
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		return (
			<section id="contact" className="Contact">

				<div className="contact">
					<Container>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={6}>
								<div className="heading-left-light">
									<h2>{selectedLanguage.addressBlock.title}</h2>

									<p>Casa #451 calle 4 esquina 17, Vista Alegre, Santiago de Cuba</p>
									<p><abbr title="Pizarra">Teléfonos:</abbr> (+53)(22) (64)1656-4400</p>
									<p><abbr title="Corporativo">Correo:</abbr> meteorologia@scu.insmet.cu</p>

									{/* <br /><br />
									<h2 >{selectedLanguage.emailBlock.title}</h2>
									<p>{selectedLanguage.emailBlock.comment}<br /></p> */}
								</div>

								<Typography variant="h4" style={{ margin: "40px 0px 10px" }}>Visítanos en las Redes Sociales</Typography>
								<ul className="socials">
									<li><a href="https://m.facebook.com/Centro-Meteorol%C3%B3gico-Provincial-Santiago-de-Cuba-430142564038821" target="_blank"><Icon className="fa fa-facebook" /></a></li>
									{/* <li><a href=""><Icon className="fa fa-google-plus" /></a></li>
									<li><a href=""><Icon className="fa fa-linkedin" /></a></li>
									<li><a href=""><Icon className="fa fa-twitter" /></a></li>
									<li><a href=""><Icon className="fa fa-skype" /></a></li>
									<li><a href=""><Icon className="fa fa-github" /></a></li>
									<li><a href=""><Icon className="fa fa-youtube" /></a></li> */}
								</ul>
							</Grid>
							<Grid item xs={12} sm={6}>
								<div className="form">
									<div className="form-wrap">
										<div className="form-wrap-group">
											<input name="name" onChange={e => this.getEmailData(e)} type="text" placeholder={selectedLanguage.emailBlock.placeHolderName} className="form-control" />
											<input name="subject" onChange={e => this.getEmailData(e)} type="text" placeholder={selectedLanguage.emailBlock.placeHolderSubject} className="border-top-transparent form-control" />
										</div>
										<div className="form-wrap-group border-left-transparent">
											<input name="mail" onChange={e => this.getEmailData(e)} type="text" placeholder={selectedLanguage.emailBlock.placeHolderEmail} className="form-control" />
											<input name="phone" onChange={e => this.getEmailData(e)} type="text" placeholder={selectedLanguage.emailBlock.placeHolderPhone} className="border-top-transparent form-control" />
										</div>
									</div>
									<textarea rows="8" name="message" onChange={e => this.getEmailData(e)} placeholder={selectedLanguage.emailBlock.placeHolderMessage} className="border-top-transparent form-control"></textarea>
									<button onClick={() => this.sendEmail()} type="submit" className="btn-danger btn-md btn-block">
										{selectedLanguage.emailBlock.buttonText}
									</button>
								</div>
							</Grid>
							<Grid item xs={12} style={{ marginTop: 30 }}>
								<div className="" id="map">

								</div>
							</Grid>
						</Grid>
					</Container>
				</div>

			</section>
		);
	}
}

export default Contact;